export const getSubdomainFromPath = (): string | undefined => {
  const path = window.location.pathname.split("/").slice(1)
  if (path?.[0] === "") {
    return undefined
  }
  return path?.[0]
}
